import React from 'react';
import { useStoreActions, useStoreState } from 'easy-peasy';
import { Container, Row, Button, Col, ToggleButton, ToggleButtonGroup, Alert, Form } from 'react-bootstrap';
import { useMemo, useState } from 'react';
import useCustomGetStoreState from "../../../../hooks/useCustomGetStoreState";
import UsersByClientComponent from '../../../users/UsersByClientComponent.jsx';
import CreateUpdateUserComponent, { submitUserForm } from '../../../users/CreateUpdateUserComponent.jsx';

import AuthorizationChecker from "../../../../services/AuthorizationChecker.js";
import { useToast } from '../../../../hooks/useToast.jsx';

const ClientUserTabComponent = ({clientById, setModalData, modalData, setModalShow, fromAccountPage=false}) => {

    const { createUser, setCreateFormErrors } = useStoreActions(actions => actions.users);
    const { changePasswordRotation } = useStoreActions(actions => actions.clients);

    const { apiData: { ACTIONS } } = useStoreState(state => state.actionSlugs);
    const { allUsers } = useCustomGetStoreState("users");
    const toast = useToast();
    const [clientHasPasswordRotation, setClientHasPasswordRotation] = useState(clientById?.hasPasswordRotation ?? false);

    const allUsersEmails = useMemo(() => {
        return allUsers
            ? allUsers.map(u => u.email)
            : [];
    }, [allUsers]);
    
    const CardClassName = fromAccountPage ? "tab-info-card tab-info-card--noMinHeight tab-info-card--noBackground-color" :"tab-info-card tab-info-card--noMinHeight";

    const canCreateUser = !AuthorizationChecker.hasReadAllRights('clientsCRM') && AuthorizationChecker.hasCreateRights('users');
    
    const createUserModal = () => {
        if(canCreateUser) {
            const validate = () => {
                const {formName} = ACTIONS['users']['create'];
                return submitUserForm(createUser, formName, clientById.uniqueId, null, allUsersEmails, true, false)
                    .then(() => {
                        toast.success();
                        setModalShow(false);
                    })
                    .catch(error => {
                        error?.formError && setCreateFormErrors(error.formError);
                    })
            }
            setModalData({
                ...modalData,
                header: <>Ajout d'un⋅e utilisateur⋅rice</>,
                content: <CreateUpdateUserComponent action="create" targetClient={clientById?.uniqueId} />,
                cancelButton: 'Annuler',
                onValidate: validate,
                size: 'lg'
            });
            setModalShow(true);
        }
    };

    const sendForm = (hasRotation, applyToAllNetwork) => {
        changePasswordRotation({ uniqueId: clientById.uniqueId, hasPasswordRotation: hasRotation, applyToAllNetwork: applyToAllNetwork })
            .then((response) => {
                toast.open({ message: "Réinitialisation du mot de passe modifiée", variant: "success" });
                setClientHasPasswordRotation(hasRotation);
                setModalShow(false);
            });
    }

    const passwordRotationModal = (hasRotation) => {
        setModalData({
            ...modalData,
            header: <>Modifier la réinitialisation du mot de passe</>,
            content: <>
                <Alert variant='danger'>
                    {hasRotation ?
                        "Les utilisateur⋅rices de ce client devront modifier leur mot de passe tous les 90 jours"
                        : "Les utilisateur⋅rices de ce client pourront garder leur mot de passe indéfiniement"}
                </Alert>
                {clientById?.clientChildren?.length > 0 && <Form.Check
                    name="applyToAllNetwork"
                    id='applyToAllNetwork'
                    type='checkbox'
                    label="Appliquer aussi ce réglage à l'ensemble du réseau de ce client"
                    defaultChecked={false} />}
            </>,
            cancelButton: 'Annuler',
            onValidate: () => { sendForm(hasRotation, document.getElementById('applyToAllNetwork')?.checked) },
            size: 'lg'
        });
        setModalShow(true);
    };

    return (
        <Container className={CardClassName} style={{width: "fit-content", minWidth: "90%"}}>
            <Row className='tab-info-card-header mb-3'>
                <Col className="header-heading">
                    <p className="header-desc">Gérez vos utilisateur⋅rices</p>
                </Col>
                {AuthorizationChecker.isAdmin() && <Col className='d-flex justify-content-end align-items-center p-0'>
                    <strong>Réinitialisation du mot de passe :</strong>
                    <ToggleButtonGroup type="radio" name="client_has_rotation" onChange={passwordRotationModal}
                        value={clientHasPasswordRotation} className='ms-2'>
                        <ToggleButton value={true} checked={!!clientHasPasswordRotation}
                            key="playlist_not_in_group" id="no_rotation">90 jours</ToggleButton>
                        <ToggleButton value={false} checked={!clientHasPasswordRotation}
                            key="playlist_in_group" id="has_rotation">Jamais</ToggleButton>
                    </ToggleButtonGroup>
                </Col>}  
                { canCreateUser &&
                <Col className="header-action">
                    <Button variant="success" onClick={() => {
                        createUserModal();
                        }
                    }><i className="fas fa-plus"></i> &nbsp;Ajout utilisateur⋅rice</Button>
                </Col>
                }
            </Row>
            <Row>
                <Col><UsersByClientComponent client={clientById}/></Col>
            </Row>
        </Container>
    );
}

export default ClientUserTabComponent;